"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContentEditorState = exports.useContentEditor = void 0;
var react_1 = require("react");
var draft_js_1 = require("draft-js");
var draftjs_md_converter_1 = require("draftjs-md-converter");
var index_1 = require("./index");
var constants_1 = require("./constants");
function useContentEditor() {
    return react_1.useContext(index_1.ContentEditorContext);
}
exports.useContentEditor = useContentEditor;
function useContentEditorState(_a) {
    var value = _a.value, readOnly = _a.readOnly;
    var _b = react_1.useState(value
        ? draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(draftjs_md_converter_1.mdToDraftjs(value || "", constants_1.CONTENT_EDITOR_CUSTOM_CONFIGS.mdToDraftJs)))
        : draft_js_1.EditorState.createEmpty()), editorState = _b[0], setEditorState = _b[1];
    react_1.useEffect(function () {
        if (readOnly) {
            var newContent = draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(draftjs_md_converter_1.mdToDraftjs(value || "", constants_1.CONTENT_EDITOR_CUSTOM_CONFIGS.mdToDraftJs)));
            setEditorState(newContent);
        }
    }, [value, readOnly, setEditorState]);
    return { editorState: editorState, setEditorState: setEditorState };
}
exports.useContentEditorState = useContentEditorState;
//# sourceMappingURL=hooks.js.map